import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useLocalization from '../../../../../hooks/useLocalization';
import {MIN_WAU} from '../constants';

const CODES = {
    moreUsers: 'epic.affiliate.fortnite_games.performance.more_users',
    currentUsers: 'epic.affiliate.fortnite_games.performance.current_users'
};

export interface InsufficientWauMessageProps {
    wau: number;
}

const InsufficientWauMessage: React.FC<InsufficientWauMessageProps> = ({
    wau
}: InsufficientWauMessageProps) => {
    const getMessage = useLocalization();

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="100%">
            <Typography variant="h5">{getMessage(CODES.moreUsers)}</Typography>
            <Typography variant="h5" color="textSecondary">
                {getMessage(CODES.currentUsers, [wau, MIN_WAU])}
            </Typography>
        </Box>
    );
};

export default InsufficientWauMessage;
